import React from 'react';
import { useIntl } from 'react-intl';
import { MenuItem, Select, TextField } from '@mui/material';
import { NEW_LAYOUT } from './useLayoutEdit';

/**
 * Which of a section's saved layouts is being edited, or a new one, and the name it is saved under.
 *
 * @param {Object} props - Component props.
 * @param {Array} props.layouts - The section's saved layouts.
 * @param {Number} props.value - The id of the layout chosen; null for a new one.
 * @param {String} props.name - The name it is saved under.
 * @param {Object} props.sx - Sizes both fields.
 * @param {Function} props.onSelect - Receives the id chosen, or `NEW_LAYOUT`.
 * @param {Function} props.onNameChange - Receives the name typed.
 *
 * @returns {React.JSX.Element}
 */
const LayoutPicker = function LayoutPicker({
  layouts = [],
  value = null,
  name = '',
  sx = {},
  onSelect = () => {},
  onNameChange = () => {},
}) {
  const intl = useIntl();

  return (
    <>
      <Select
        id="layout-select"
        size="small"
        value={value ?? NEW_LAYOUT}
        onChange={(e) => onSelect(e.target.value)}
        sx={sx}
      >
        {layouts.map((layout) => (
          <MenuItem key={layout.id} value={layout.id}>
            {layout.isDefault
              ? `${layout.name} (${intl.messages.DEFAULT})`
              : layout.name}
          </MenuItem>
        ))}
        <MenuItem value={NEW_LAYOUT}>{intl.messages.NEW_LAYOUT}</MenuItem>
      </Select>
      <TextField
        size="small"
        label={intl.messages.NAME}
        value={name}
        onChange={(e) => onNameChange(e.target.value)}
        sx={sx}
      />
    </>
  );
};

export default LayoutPicker;
